import { INITIAL_TABLE_STATE as INITIAL_INTEREST_TABLE_STATE, InterestTableState } from './InterestTableState';

export interface PageableTableState extends InterestTableState {
    pageLoading: boolean;
    total: number;
}

export const INITIAL_TABLE_STATE: PageableTableState = {
    ...INITIAL_INTEREST_TABLE_STATE,
    pageLoading: false,
    total: 0,
};
